import axios from "@/app/Axios";
class ArmaOrganicaIndex {
  async index() {
    try {
      const response = await axios.get("/arma_organico");
      return response.data;
    } catch (error) {
      console.log(error);
      console.log(error.response.data);
      const errorData = error.response.data;
      return errorData;
    }
  }
  async submitForm(datosArma) {
    try {
      const response = await axios.post("/armas", datosArma);
      console.log("Respuesta del servidor:", response.data);
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        return error.response.data;
      } else {
        console.error("Error al enviar el formulario:", error);
        throw error; // Re-lanzar el error para que pueda ser manejado por el código que llama a este servicio
      }
    }
  }

  async updateForm(id, datosArma) {
    try {
      const response = await axios.put(`/armas/${id}`, datosArma);
      console.log("Respuesta del servidor:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error al actualizar el formulario:", error);
      throw error;
    }
  }
}

export default new ArmaOrganicaIndex();
